/**
 * HTML utility functions for text manipulation and sanitization
 */

/**
 * Decodes HTML entities in a string (e.g., converts &amp; to &)
 * Uses DOMParser for efficient parsing without creating DOM elements
 *
 * @param {string} html - HTML string with encoded entities
 * @returns {string} Decoded text content
 *
 * @example
 * decodeHtml('Career &amp; Technical Education')
 * // Returns: 'Career & Technical Education'
 */
export const decodeHtml = (html) => {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
};

export default {
    decodeHtml,
};
